import styled from '@emotion/styled'
import { color, ColorProps, WidthProps } from 'styled-system'
import MotionFlex from '../MotionFlex'

type SpacerLineProps = ColorProps & WidthProps

export const SpacerLine = styled(MotionFlex)`
  position: relative;
  left: 0;
  right: 0;
  width: 2px;
`

export const Square = styled.div`
  width: 40px;
  height: 25px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
`

export const OuterCircle = styled<'div', ColorProps>('div')`
  ${color};
  width: 24px;
  height: 24px;
  display: flex;
  border-radius: 15px;
  align-items: center;
  justify-content: center;
`
